/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


export const generateDocumentFromBinary = (FILE: string, fileType = "application/pdf") : void | null => {

    if (!FILE) return null;

    const binaryString = window.atob(FILE);
    const binaryStringLen = binaryString.length;

    const bytes = new Uint8Array(binaryStringLen);

    for (let i = 0; i < binaryStringLen; ++i) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    const OUTPUT_FILE = new Blob([bytes], {type: fileType});

    const OUTPUT_FILE_URL = URL.createObjectURL(OUTPUT_FILE);

    window.open(OUTPUT_FILE_URL);

};


export default generateDocumentFromBinary;
